<template>
  <div id="preview" class="in-app-preview">
    <div class="in-app-preview-wrapper">
      <div class="in-app-preview-body">
        <component :is="component" :template="template" :isStep="isStep" :key="key"></component>
      </div>
      <div class="in-app-preview-empty">
        Данное отображение дает общее представление о том, как Ваше сообщение
        будет отображаться на мобильном устройстве. Фактическое отображение
        сообщения зависит от самого устройства
      </div>
    </div>
  </div>
</template>

<script>
import methods from "@/components/nodes/previewMethods.js";

export default {
  name: "InAppPreview",

  props: {
    template: {
      type: Object,
      default: null
    }
  },

  mixins: [methods],

  data: () => ({
    component: () => null,
    key: 1,
    forms: {
      "0": "InAppCard",
      "1": "InAppModal",
      "2": "InAppImageOnly",
      "3": "InAppTopBanner"
    }
  }),

  created() {
    if (this.template.InAppProps.MessageType) {
      this.component = () =>
        import(
          `./PreviewTemplates/types/${
            this.forms[this.template.InAppProps.MessageType]
          }.vue`
        );
    }
  },

  watch: {
    "template.InAppProps.MessageType"() {
      (this.component = () =>
        import(
          `./PreviewTemplates/types/${
            this.forms[this.template.InAppProps.MessageType]
          }.vue`
        )),
        setTimeout(() => ++this.key);
    }
  },

  methods: {
    onOpenUrl(url) {
      window.open(url, "_blank");
    }
  }
  // mounted() {
  //   scaleHeight(".template--wallet", ".wallet-preview", 255, 764);
  // }
};
</script>

<style lang="scss">
$preview-width: 521px;
// $border-value: 1px solid #d7d7d7;

@function main-height() {
  @return $preview-width * 0.26;
}
@function banner-height() {
  @return $preview-width * 0.3172;
}

.in-app-preview {
  display: grid;
  grid-template-columns: 1fr;

  justify-items: center;
  transform: scale(0.9);

  &-body {
    background-color: #fff;
    margin: 0 auto;
    width: $preview-width;
    // border: $border-value;
    box-sizing: border-box;
    margin-bottom: 7px;
    overflow: hidden;
  }

  &-empty {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #6d6d6d;
    overflow: hidden;
  }
}
</style>
